<template>
  <div>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>

    </ion-toolbar>

    <div class="main_wrapper ion-padding">
      <div class="container">
        <div class="auth-header">
          <div class="auth-heading">
            <h1>AHPRA Verification</h1>
            <span>Please verify your pharmacist registration with AHPRA</span>
          </div>
          <div class="brand-icon">
            <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
          </div>
        </div>
        <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
          :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="goNext('userForm')"
          @keyup.enter="goNext('userForm')">
          <el-form-item class="no-scroll" label="AHPRA Registration number" prop="ahpraNumber" :required="true">
            <div class="el-input">
              <input class="el-input__inner" :ref="(el) => (formsData.userForm.ahpraNumber.ref = el)"
              :value="formsData.userForm.ahpraNumber.value" :placeholder="'AAA 000000000'"
              v-imask="formsData.userForm.ahpraNumber.mask"
              @accept="onFormMaskAccept($event, 'userForm', 'ahpraNumber')"
              @blur="checkFormValidation('userForm', true, 'ahpraNumber')" />
            </div>
           
          </el-form-item>
          <el-form-item class="no-scroll" label="Expiry Date" prop="ahpraExpiryDate" :required="true">
            <el-date-picker popper-class="datepicker_popper drawer-style-ahpra" v-model="formsData.userForm.ahpraExpiryDate.valueFormatted"
              type="date" placeholder="DD/MM/YYYY" :format="$filters.systemDateFormat()" @change="dateConvert">
            </el-date-picker>
            <!-- <input
              type="tel"
              class="el-input__inner"
              :value="formsData.userForm.ahpraExpiryDate.value"
              :placeholder="'DD/MM/YYYY'"
              v-imask="formsData.userForm.ahpraExpiryDate.mask"
              @accept="onFormMaskAccept($event, 'userForm', 'ahpraExpiryDate')"
              @blur="checkFormValidation('userForm', true, 'ahpraExpiryDate')"
            /> -->
          </el-form-item>
          <el-form-item class="button_submit mb0" v-if="routeName == 'auth_ahpra' || routeName == 'onboard_ahpra'">
            <el-button class="submit" type="blue" @click="goNext('userForm')" :disabled="formsData.userForm.disabled">
              Continue
            </el-button>
          </el-form-item>
        </el-form>
        <div class="background-circles">
          <div class="circle circle-2"></div>
          <div class="circle circle-1"></div>
          <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, inject } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { useStore } from "vuex";

import { useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import formMasks from "@/hooks/form/mask/mask";

import IMaskDirective from "@/directives/vue-imask/directive";
import IMask from "imask/esm/imask";

import { ElMessageBox } from "@/components/Vendor/Element";
import SvgIcon from '@/components/Svg/SvgIcon.vue';

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon,
  },
  directives: {
    imask: IMaskDirective,
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const setPageClassGlobal = inject("setPageClassGlobal");

    const userData = $store.getters.GET_USER_DATA;
    const ahpra = userData.ahpra;
    const $moment = inject(["$moment"]);
    const routeName = $route.name;
    const reverseAphraDate = (date) => {
      let newDate = date.split("-").reverse();
      return newDate[0] + "-" + newDate[1] + "-" + newDate[2];
    };
    const dateConvert = () => {
          if (formsData.userForm.ahpraExpiryDate.valueFormatted) {
            const result = $moment(formsData.userForm.ahpraExpiryDate.valueFormatted, "YYYY-MM-DD").format(
              "YYYY-MM-DD")
              console.log("change asdadsa",result);
            formsData.userForm.ahpraExpiryDate.value = result
            console.log("after change asdadsa",formsData.userForm.ahpraExpiryDate.value);
          } else {
            return null;
          }
        };
    const ahpraExpiryDateValue = ahpra.date
      ? $moment(ahpra.date, ["YYYY-MM-DD"])
      : new Date(new Date().setFullYear(new Date().getFullYear() ));

    const formsDataArray = {
      userForm: {
        ahpraNumber: {
          value: ahpra.number
            ? IMask.createMask(formMasks.ahpraNumber).resolve(ahpra.number)
            : "",
          mask: formMasks.ahpraNumber,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "ahpra",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
        ahpraExpiryDate: {
          ref: null,
          value: ahpra.date
            ? IMask.createMask(formMasks.ahpraExpiryDate).resolve(
                reverseAphraDate(ahpra.date)
              )
            : "",
          valueFormatted: ahpraExpiryDateValue,
          resetValue: true,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  {
                    rule: "ahpraExpiryDate",
                  },
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
      },
    };

    const goBack = async() => {
      await $store.dispatch("getAuthPageBack");
      $router.push({
          name: 'onboard_gender',
      });  
    };

    const goNext = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          return (async () => {
            try {
                await $store.dispatch(
                  "SAVE_USER_DATA",
                  getFormValues(formName)
                );
                $router.push({
                  name: "onboard_address",
                });
              
            } catch (error) {
              console.log("error submit!!");
            }
          })();
        } else {
          setFormValidation(formName, false, false);
          console.log("error submit!!");
          return false;
        }
      });
    };

    onBeforeRouteLeave((to, from, next) => {
      if (routeName == "profile_ahpra") {
        (async () => {
          try {
            let leave = await checkFormChanged("userForm");
            if (leave == "save") {
              await goNext("userForm");
            } else if (!leave) {
              next(false);
            } else {
              next();
            }
          } catch (error) {
            next(false);
            console.log(error);
          }
        })();
      } else {
        next();
      }
    });

    const skip = () => {
      (async () => {
        try {
          await ElMessageBox.confirm(
            ``,
            "Do you want to skip? You will be unverified",
            {
              distinguishCancelAndClose: true,
              showConfirmButton: true,
              confirmButtonText: "Skip",
              cancelButtonText: "Cancel",
              confirmButtonClass: "el-button--green",
              cancelButtonClass: "el-button--grey",
              showClose: true,
            }
          );
        } catch {
          return;
        }
        try {
          await $store.dispatch("addAuthPageBack", $route.name);
          $router.push({
            name: "onboard_address",
          });
        } catch (error) {
          console.log(error);
        }
      })();
    };

    onMounted(() => {
      setPageClassGlobal("global_onboard_internal_page");
      setFormRefs();
      formsRefs.userForm.value.$el[0].focus();
      dateConvert();
      if (routeName == "profile_ahpra") {
        checkFormValidation("userForm", true);
      } else {
        checkFormValidation("userForm", false);
      }
    });

    const {
      ["onFormMaskAccept"]: onFormMaskAccept,
      checkFormValidation,
      setFormValidation,
      checkFormChanged,
      getFormValues,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    return {
      formsData,
      onFormMaskAccept,
      checkFormValidation,
      goBack,
      goNext,
      skip,
      routeName,
      dateConvert
    };
  },
};
</script>
